module.exports = __webpack_public_path__ + "static/insta-292813c9c8ba9183d10a40e62d79502a.jpg";